import { LicenseInfo } from '@mui/x-license';

// Replace this with your actual license key from MUI dashboard
LicenseInfo.setLicenseKey('2fe0352e7ddc062757889b56620fdfd0Tz0xMDA2NjMsRT0xNzYxNDUwMTU5MDAwLFM9cHJvLExNPXN1YnNjcmlwdGlvbixQVj1RMy0yMDI0LEtWPTI=');
